import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ButtonLinkProps {
    href: string
    children: ReactNode
    variant?: 'primary' | 'secondary' | 'ghost'
    size?: 'sm' | 'md' | 'lg'
    arrow?: boolean
    className?: string
    onClick?: () => void
}

const variantClass = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    ghost: 'btn-ghost'
}

const sizeClass = {
    sm: 'btn-sm',
    md: '',
    lg: 'btn-lg'
}

const ButtonLink: FC<ButtonLinkProps> = ({
    href,
    children,
    variant = 'primary',
    size = 'md',
    arrow = false,
    className,
    onClick
}): ReactNode => {
    return (
        <Link
            href={href}
            onClick={onClick}
            className={cn('btn', variantClass[variant], sizeClass[size], className)}
        >
            {children}

            {arrow && <ArrowRight className='btn-arrow size-4 -mr-0.5' aria-hidden='true' />}
        </Link>
    )
}

export default ButtonLink
